import React, { Fragment } from 'react';
import Typography from '@material-ui/core/Typography';

import {
  Route,
  Switch,
  useLocation,
  useParams,
  useRouteMatch,
} from 'react-router-dom';

import {
  isLoggedUserAConsulente,
  getConsulenteId,
  isSuperconsulente,
  getGruppoId,
} from '../../utils/storage.js';

import AbbonamentiTable from './tabelle/AbbonamentiTable';
import ConsulentiTable from './tabelle/ConsulentiTable';
import EserciziCommercialiTable from './tabelle/EserciziCommercialiTable';
import ModelliPersonalizzatiTable from './tabelle/ModelliPersonalizzatiTable.js';
import ManualiPersonalizzatiTable from './tabelle/ManualiPersonalizzatiTable.js';
import ResponsabiliSicurezzaTable from './tabelle/ResponsabiliSicurezzaTable';
import GruppiTable from './tabelle/GruppiTable';
import BrandTable from './tabelle/BrandTable.js';
import ClientiRemoteApp from './clienti/ClientiRemoteApp.js';

import { useTheme } from '@material-ui/core';
import PageNotFound from '../../pages/PageNotFound.jsx';
import { getCurrentAdminSection, validTabs } from './controlPanelNavigation.js';

const styles = {
  mainContainer: {
    textAlign: 'center',
    color: 'black',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  controlPanelContainer: {
    overflow: 'hidden',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
};

export default function ControlPanel() {
  const match = useRouteMatch();
  const location = useLocation();
  const currentTab = getCurrentAdminSection(location.pathname);

  const controlPanelContainerStyle = {
    ...styles.controlPanelContainer,
    padding: currentTab === 'clienti' ? 0 : '20px',
  };

  /**
   * The amministrazione shell is full viewport height while many tabs render short content,
   * which used to leave a large empty band below. Vertically center that content when it fits.
   * `safe center` falls back to top alignment when content overflows (no extra scroll container;
   * long pages keep using the same document/page scroll as before this layout tweak).
   */
  const tableAreaLayoutStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'safe center',
    minHeight: 0,
  };

  return (
    <div id="main_component_container" style={styles.mainContainer}>
      <div style={controlPanelContainerStyle}>
        <div style={tableAreaLayoutStyle}>
          <Switch>
            <Route path={`${match.path}/:tablename`}>
              <TableComponent />
            </Route>
            <Route path={`${match.path}`}>
              <TextComponent />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
}

function TableComponent() {
  const theme = useTheme();
  const consulenteId = isLoggedUserAConsulente()
    ? Number.parseInt(getConsulenteId(), 10)
    : null;
  const superconsulenteView = isSuperconsulente();
  const gruppoId =
    getGruppoId() === null || getGruppoId() === 'null'
      ? null
      : Number.parseInt(getGruppoId(), 10);
  let { tablename } = useParams();

  if (!validTabs.includes(tablename)) return <PageNotFound />;

  let table = null;

  if (tablename === 'responsabili_sicurezza') {
    table = (
      <ResponsabiliSicurezzaTable
        consulenteId={consulenteId}
        superconsulenteView={superconsulenteView}
        gruppoId={gruppoId}
        theme={theme}
      />
    );
  } else if (tablename === 'consulenti') {
    table = (
      <ConsulentiTable
        consulenteId={consulenteId}
        superconsulenteView={superconsulenteView}
        gruppoId={gruppoId}
        theme={theme}
      />
    );
  } else if (tablename === 'esercizi_commerciali') {
    table = (
      <EserciziCommercialiTable
        consulenteId={consulenteId}
        superconsulenteView={superconsulenteView}
        gruppoId={gruppoId}
        theme={theme}
      />
    );
  } else if (tablename === 'modelli_manuali') {
    table = (
      <ModelliPersonalizzatiTable
        consulenteId={consulenteId}
        superconsulenteView={superconsulenteView}
        gruppoId={gruppoId}
        theme={theme}
      />
    );
  } else if (tablename === 'manuali') {
    table = (
      <ManualiPersonalizzatiTable
        consulenteId={consulenteId}
        superconsulenteView={superconsulenteView}
        gruppoId={gruppoId}
        theme={theme}
      />
    );
  } else if (tablename === 'abbonamenti') {
    table = <AbbonamentiTable theme={theme} />;
  } else if (tablename === 'gruppi') {
    table = <GruppiTable theme={theme} />;
  } else if (tablename === 'brand') {
    table = <BrandTable />;
  } else if (tablename === 'clienti') {
    table = <ClientiRemoteApp />;
  }
  return <Fragment>{table}</Fragment>;
}

function TextComponent() {
  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h5">
        Selezionare la sezione da visualizzare tramite la navigazione in alto
      </Typography>
    </div>
  );
}
